<template>
  <div class="contain" id="jumpintro">
      <div class="main-core">{{getLan('3783278c-80e5-4ff6-99a8-c239b183dfd0')}}</div>
      <div class="core-description" style="    max-width: 90%;margin: 0 5%;">{{getLan('53830f39-a415-4a7f-97ec-dc867e3676f0')}}<br>{{getLan('d998c23e-4603-4881-9ca5-ef7f2ec5d71f')}}</div>
      <div class="learn-more" @click="goIntro">{{getLan('1f26e983-0c5b-4e93-bae7-b5f1e176838a')}}<img src="@/assets/topbar/more.png" style="margin-left: 0.73rem"/></div>
      <a :href="`./#/intro?lan=${bus.nowLan}`" v-show="false" id="goIntro" target="_blank"/>
  </div>
</template>

<script>
export default {
    data() {
        return {
            mainCore: '将平凡无趣的时间转化为有意义的时光',
            description1: '乐信圣文（Learnings）是一家全球领先的移动出海应用开发商，',
            description2: '坚持做“有格局负责任的奋斗者”，致力于为全球用户提供最棒的移动应用。'
        }
    },
    methods: {
        goIntro() {
            document.querySelector('#goIntro').click()
        }
    }
}
</script>

<style scoped>
.contain {
    padding-top: 5.39rem;
    padding-bottom: 4.29rem;
    text-align: center;
    width: 100rem;
    box-sizing: border-box;
    background: #fff;
}
.main-core {
    font-size: 2.51rem;
    font-weight: 500;
    color: rgba(51,51,51,1);
    line-height: 3.11rem;
    margin-bottom: 2.09rem;
}
.core-description {
    color: rgba(102,102,102,1);
    opacity: 0.85;
    font-size: 1.26rem;
    line-height: 1.78rem;
    margin-bottom: 2.15rem;
    /* width: 41.88rem; */
}

.learn-more {
    color: #FD9A27;
    font-weight: 500;
    font-size: 1.05rem;
    cursor: pointer;
}
.learn-more img {
    width: 0.68rem;
    height: 0.68rem;
}
</style>


// WEBPACK FOOTER //
// src/components/Core.vue